var render = function render(){var _vm=this,_c=_vm._self._c;return (this.showGoToTop)?_c('b-link',{staticClass:"float",attrs:{"title":"Voltar ao Topo"},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fa fa-arrow-up my-float"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }